import React, { useEffect } from "react";
import Button from "../../Elements/Button/Button";
import Loader from "../../Elements/Loader/Loader";
import Input from "../../Elements/Input/Input";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";
import useForm from "../../../Hooks/useForm";
import { setErrorFormSimpleUtil } from "../../../Utilities/Forms/errors";
import useIsMobile from "../../../Hooks/useIsMobile";
import * as Yup from "yup";

const FORM_REQUEST_RESET = {
  email: "",
};

const FormRequestResetScheme = Yup.object().shape({
  email: Yup.string()
    .email("Correo no válido")
    .required("El correo es obligatorio"),
});

const RequestPasswordReset = () => {
  const showToast = useToast();
  const {
    fetchDataRequestPasswordReset,
    loading,
    error,
    success,
    resetError,
    resetSuccess,
  } = useStore();

  const isMobile = useIsMobile();
  const bgImage = isMobile
    ? "/assets/imgs/Backgroundmob.png"
    : "/assets/imgs/Backgroundprincipal-pc.png";

  useEffect(() => {
    if (error) {
      showToast("error", error);
      resetError();
    }
  }, [error, showToast, resetError]);

  useEffect(() => {
    if (success) {
      showToast("success", success.message || "Correo enviado ✅");
      resetSuccess();
    }
  }, [success, showToast, resetSuccess]);

  const { values, errors, touched, handleBlur, handleChange, isValid } =
    useForm(FORM_REQUEST_RESET, FormRequestResetScheme);

  const submit = () => {
    if (!isValid) return;
    fetchDataRequestPasswordReset(values.email);
  };

  if (loading) return <Loader />;

  return (
    <section
      className="login-bg d-flex align-items-center min-vh-100"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "100%",
      }}
    >
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <div className="card glass border-0 shadow-lg overflow-hidden">
              <div className="card-body p-4 p-md-5">
                <div className="text-center mb-4">
                  <img
                    src="/assets/imgs/Sin fondo.png"
                    alt="BubUp"
                    className="login-logo mb-2"
                  />
                  <h4 className="fw-bold text-white mb-1">
                    Recuperar contraseña
                  </h4>
                  <p className="text-white-50 mb-0">
                    Ingresa tu correo y te enviaremos un link de recuperación
                  </p>
                </div>

                <form onSubmit={(e) => e.preventDefault()}>
                  <Input
                    value={values.email}
                    label="Correo electrónico"
                    labelColor="white"
                    onChange={handleChange("email")}
                    onBlur={handleBlur("email")}
                    error={setErrorFormSimpleUtil(errors, touched, "email")}
                    success={!setErrorFormSimpleUtil(errors, touched, "email")}
                  />
                  <div className="d-grid gap-2 mt-3">
                    <Button
                      text="Enviar enlace"
                      color="blue"
                      fill
                      action={submit}
                      disabled={!isValid}
                      classNames="w-100 py-3"
                    />
                    <Button
                      text="Volver al login"
                      color="green"
                      fill
                      action={() => (window.location.href = "/")}
                      classNames="w-100 py-3"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RequestPasswordReset;